(function () {
  if (window.__variantSliderInit) return;
  window.__variantSliderInit = true;

  console.log("%cFlickity Sliders Loaded", "color:#4CAF50; font-weight:bold;");

  /* -----------------------------------------
     ALWAYS APPLY Flickity for Variant Sliders
     (NO CONDITIONS)
  ----------------------------------------- */
  function initVariantSliders(root) {
  var scope = root || document;

  scope.querySelectorAll(".product-recommendations-placeholder .grid-product__colors.variant-slider").forEach(function (carousel) {
    if (carousel.__fkl) return;

    if (typeof Flickity === "undefined") {
      console.warn("Flickity missing for Variant Slider");
      return;
    }

    var w = window.innerWidth;
    var groupCells;

    if (w >= 1200) {
      groupCells = 4; // desktop: 4 swatches
    } else if (w >= 768) {
      groupCells = 3; // tablet
    } else {
      groupCells = 2; // mobile
    }

    carousel.__fkl = new Flickity(carousel, {
      cellAlign: "left",
      contain: true,
      wrapAround: false,
      groupCells: groupCells,
      pageDots: false,
      prevNextButtons: true,
      imagesLoaded: true,
      percentPosition: true
    });

    console.log("Variant Slider Applied with groupCells:", groupCells);
  });
}


  function initRecommendationSlider(root) {
    var scope = root || document;

    scope.querySelectorAll(".product-recommendations-placeholder .grid").forEach(function (carousel) {
      if (carousel.__fkl) return;

      let cardCount = carousel.querySelectorAll(".product-card, .grid__item, .card").length;

      let isDesktop = window.innerWidth >= 1024;
      let shouldApply =
        (isDesktop && cardCount > 5) ||
        (!isDesktop && cardCount > 2);

      console.log("Rec Cards:", cardCount, "Desktop:", isDesktop, "Apply:", shouldApply);

      if (!shouldApply) {
        console.warn("Recommendation slider not applied — card count too low");
        return;
      }

      if (typeof Flickity === "undefined") {
        console.warn("Flickity missing for Recommendations");
        return;
      }

      carousel.__fkl = new Flickity(carousel, {
        cellAlign: "left",
        contain: true,
        groupCells: false,
        wrapAround: true,
        pageDots: false,
        prevNextButtons: true,
        imagesLoaded: true
      });

      console.log("Recommendation Slider Applied");
    });
  }

  function initAllSliders(root) {
    // initVariantSliders(root);     
    initRecommendationSlider(root);  
    // initSameSlider(root);
  }

  document.addEventListener("DOMContentLoaded", function () {
    initAllSliders(document);
  });

  window.addEventListener("load", function () {
    initAllSliders(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initAllSliders(event.target);
  });

  document.addEventListener("shopify:section:reorder", function (event) {
    initAllSliders(event.target);
  });
})();

document.addEventListener('DOMContentLoaded',()=>{
  let collection__description = document.querySelector('.collection__description');
  let btnLoadmore = document.querySelector('[data-botton-load-more]');
  if(collection__description && btnLoadmore){
    btnLoadmore.addEventListener('click',()=>{
      btnLoadmore.classList.toggle('show_more');
      collection__description.classList.toggle('show_more');
    })
  }
  let filter = document.querySelector('#FilterDrawer');
  let filterClose =  document.querySelector("#FilterDrawer .drawer__close");
  let openFilter = document.querySelector('.js-drawer-open-collection-filters');
  if( filter && openFilter){
    openFilter.addEventListener('click',()=>{
filter.classList.toggle('drawer--is-open');
    });
    if(filterClose){
      filterClose.addEventListener('click',()=>{
      filter.classList.remove('drawer--is-open');
      })
    }
    
  }
  let OpenGuide = document.querySelector('.collection-sidebar__group [data-fancybox]');
  let openGuideContainer = document.querySelector('.overlay');
  let btnFitClose = document.querySelector('[btn-fit-close]');
  if(OpenGuide && openGuideContainer && btnFitClose){
    OpenGuide.addEventListener('click',(e)=>{
      e.preventDefault();
      openGuideContainer.style.display ="flex";
    })
        btnFitClose.addEventListener('click',(e)=>{
      e.preventDefault();
      openGuideContainer.style.display ="none";
    })
  }
})


